import { apiFetch } from "@/lib/api";

import type { KittingPickLaborAllocationTarget } from "./kittingPickLaborModel";

export interface KittingPickLaborAllocationPayloadRow {
  slotKey: string;
  quantity: number;
  target: KittingPickLaborAllocationTarget;
}

export async function syncKittingPickLaborAllocations(input: {
  sessionId: number;
  allocations: KittingPickLaborAllocationPayloadRow[];
}): Promise<{ synced: number }> {
  return apiFetch<{ synced: number }>("/api/manufacturing/kitting/labor/sync-pick-allocation", {
    method: "POST",
    body: {
      sessionId: input.sessionId,
      allocations: input.allocations,
    },
  });
}
